import environment from '../../../../../common/environment';
import {
  getLoginURLWithRedirectUrlToPage,
} from '../../../../../common/utils/login-utils';
import {
  addAuthTokenToCookieForSession,
} from '../../../../../common/utils/util';
import { checkValidityOfToken } from '../../../../user-profile/api/get-user-profile';
import { SSOUtils } from '../../../utils/sso.utils';
import { ISSOFromWindow } from './sso-from-window.interface';

export class SSOFromWindow implements ISSOFromWindow {
  private ssoUtils: SSOUtils;

  constructor(ssoUtils: SSOUtils) {
    this.ssoUtils = ssoUtils;
  }

  postReadyToSSO(destination: string, targetOrigin: string) {
    if (window.opener) {
      console.log('Posting ready message');
      window.opener.postMessage(
        {
          destination,
          source: 'mheducation',
          status: 'ready',
        },
        { targetOrigin }
      );

      this.listenForTokenExchange(destination);
    }
  }

  private listenForTokenExchange(source: string): void {
    window.addEventListener('message', async (event) => {
      if (event.data?.source !== source) {
        return;
      }
      const redirectUrl = this.ssoUtils.fillInitialBarIfNotPresent(event.data);
      const validOrigin = this.ssoUtils.isValidOrigin(event.origin);
      if (event.source && validOrigin) {
        if (event.data?.token) {
          try {
            const userInfo = await checkValidityOfToken(event.data.token);
            if (userInfo.userType && userInfo.persona) {
              addAuthTokenToCookieForSession(event.data!.token);
              if (redirectUrl) {
                window.location.href = redirectUrl;
              } else {
                window.location.href = environment().accountUrl;
              }
            }
          } catch (err) {
            console.log(`Token is not valid, redirecting user to the login page. Error: ${err}`);
            window.location.href = getLoginURLWithRedirectUrlToPage(window.location.origin + redirectUrl);
          }
        } else {
          console.log('Token is not present or the origin is not accepted.');
          window.location.href = getLoginURLWithRedirectUrlToPage(window.location.origin + redirectUrl);
        }
      }
    });
  }
}
